import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";

import App from "./App.tsx";
import ErrorFallback from "./components/ErrorFallback.tsx";

import "@excalidraw/excalidraw/index.css";
import "./index.css";

Sentry.init({
  dsn: "https://46d6cd1712895c67735a50bd5881699f@o4509665474510848.ingest.us.sentry.io/4509665535066112",
  enableLogs: true,
  sendDefaultPii: true,
  environment: import.meta.env.VITE_PUBLIC_STAGE,
  enabled: import.meta.env.MODE === "production",
  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ["error", "warn"] }),
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.2,
});

createRoot(document.getElementById("root") as HTMLElement).render(
  <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog>
    <App />
  </Sentry.ErrorBoundary>
);
